import React, { createContext, useState, ReactNode } from "react";

import ConfirmDialog from "../components/ConfirmDialog";

type ConfirmationDialogData = {
  title: string;
  message: ReactNode;
  confirmBtnMsg?: string;
  onConfirm?: () => void;
};

export type ConfirmationDialogReturn = {
  openDialog: (data: ConfirmationDialogData) => void;
  closeDialog: () => void;
};

const ConfirmationDialogContext = createContext<
  ConfirmationDialogReturn | undefined
>(undefined);

export { ConfirmationDialogContext };

type ConfirmationDialogProviderProps = {
  children: ReactNode;
};

export const ConfirmationDialogProvider = ({
  children,
}: ConfirmationDialogProviderProps): React.JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);
  const [dialogData, setDialogData] = useState<ConfirmationDialogData | null>(
    null,
  );

  const openDialog = (data: ConfirmationDialogData): void => {
    setDialogData(data);
    setIsOpen(true);
  };

  const closeDialog = (): void => {
    setIsOpen(false);
    setDialogData(null);
  };

  const handleConfirm = (): void => {
    dialogData?.onConfirm?.();
    closeDialog();
  };

  const handleClose = (): void => {
    closeDialog();
  };

  return (
    <ConfirmationDialogContext.Provider value={{ openDialog, closeDialog }}>
      {children}
      {dialogData && (
        <ConfirmDialog
          isOpen={isOpen}
          title={dialogData.title}
          message={dialogData.message}
          confirmBtnMsg={dialogData.confirmBtnMsg}
          onConfirm={handleConfirm}
          onClose={handleClose}
          closeBtnMsg="Cancel"
          contentColor="text.primary"
        />
      )}
    </ConfirmationDialogContext.Provider>
  );
};
